import styled from "styled-components"

import Button from "components/presenters/common/form/Button"

export default function SubmitButton({ isValid, onClick }) {
  return (
    <ButtonStyle onClick={onClick} fullWidth disabled={!isValid}>
      배송지 추가하기
    </ButtonStyle>
  )
}

const ButtonStyle = styled(Button)`
  padding: calc(100vw * (23 / 375)) 0;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
`
